<ng-container *ngIf="report$ != null"></ng-container>
<mat-icon *ngIf="report$ | async as rep" class="favorite" (click)="setFavorite(rep, $event)"
    [matTooltip]="rep.favorite ? 'Remove favorite' : 'Add favorites'">
    {{ rep.favorite == true ? "bookmark" : "bookmark_outline" }}
</mat-icon>